// import Swiper bundle with all modules installed
import Swiper from "swiper/bundle";
// import { debounce as _debounce } from 'underscore';
// import { gsap } from 'gsap';
// import inView from 'in-view';

export default class {
	constructor(options) {
		// OPTIONS
		this.defaults = {
			$el: undefined,

			// Default common swiper options
			swiperArgs: {
				slidesPerView: "auto",
				grabCursor: true,
				loop: true,
				speed: 470,
				keyboard: {
					enabled: true,
					onlyInViewport: true,
				},
				paginationClickable: true,
			},
		};

		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "swiper_slideshow";

		// DOM ELEMENT !!!!!!!!!!
		this.$el = this.options.$el;

		// init!!!!
		if (this.$el.length > 0) {
			this.init();
		}
	}

	init() {
		// vars
		/*
		this.$win = $(window);
		this.$doc = $(document);
		this.$html = $('html');
		this.$body = $( 'body' );
		*/
		this.initImages();
		this.initSlider(true);
		if (this.$el.hasClass("mo-carousel")) {
			this.initSliderMo(true);
		}
		// this.onResize();
	}

	initSlider(b) {
		if (b) {
			if (this.$el.find(".swiper-slide").length <= 1) {
				return;
			}

			let args = this.options.swiperArgs;

			// add arrows navigation
			args.navigation = {
				nextEl: this.$el.find(".controls .next")[0],
				prevEl: this.$el.find(".controls .prev")[0],
			};

			// add pagination
			if (!this.$el.hasClass("module-slideshow-b")) {
				// format pagination
				let pagination = {
					el: this.$el.find(".controls .pagination")[0],
					type: "fraction",
					formatFractionCurrent: (i) => this.formatNumber(i),
					formatFractionTotal: (i) => this.formatNumber(i),
					paginationClickable: true,
				};

				args.pagination = pagination;
			}

			if (this.$el.hasClass("module-slideshow-b")) {
				args.loop = false;
				args.spaceBetween = 32;
			}

			if (this.$el.hasClass("module-slideshow-c")) {
				// args.effect = "fade";
				// args.fadeEffect = {
				// 	crossFade: true,
				// };
				// args.preventClicks = false;
				// args.preventClicksPropagation = false;

				let pagination = {
					el: this.$el.find(".controls .pagination")[0],
					type: "fraction",
					formatFractionCurrent: (i) => this.formatNumber(i),
					formatFractionTotal: (i) => this.formatNumber(i),
					// preventClicks: false,
					// preventClicksPropagation: false,
				};
				// args.loop = false;
			}

			if (this.$el.hasClass("module-slideshow-d")) {
				args.centeredSlides = true;
				args.spaceBetween = 60;
				this.centerCaptions();
				$(window).resize(this.centerCaptions);
			}

			if (this.$el.hasClass("module-slideshow-a")) {
				args.pagination = {
					el: ".pagination-dots",
					type: "bullets",
				};
				args.breakpoints = {
					// when window width is >= 320px
					768: {
						pagination: {
							el: this.$el.find(".controls .pagination")[0],
							type: "fraction",
							formatFractionCurrent: (i) => this.formatNumber(i),
							formatFractionTotal: (i) => this.formatNumber(i),
						},
					},
				};
			}

			this.swiper = new Swiper(this.$el[0], args);
		} else {
			this.swiper.destroy(true, true);
		}

		//this.addEvents( b );
	}

	initSliderMo(b) {
		let appScope = this;
		const breakpoint = window.matchMedia("(min-width:768px)");
		if (this.$el.find(".card").length <= 1) {
			return;
		}
		let mySwiper;
		const breakpointChecker = function () {
			if (breakpoint.matches === true) {
				if (mySwiper !== undefined) mySwiper.destroy(true, true);
				return;
			} else if (breakpoint.matches === false) {
				return enableSwiper();
			}
		};
		const enableSwiper = function () {
			mySwiper = new Swiper(appScope.$el[0], {
				loop: true,
				slidesPerView: 1.1,
				centeredSlides: false,
				a11y: true,
				keyboardControl: true,
				grabCursor: true,
				wrapperClass: "cards-grid",
				slideClass: "card",
				// pagination
				pagination: ".controls",
				navigation: {
					nextEl: appScope.$el.find(".controls .next")[0],
					prevEl: appScope.$el.find(".controls .prev")[0],
				},
				paginationClickable: true,
			});
		};
		// keep an eye on viewport size changes
		breakpoint.addListener(breakpointChecker);
		// kickstart
		breakpointChecker();
		// if (b) {
		// 	if (this.$el.find(".swiper-slide").length <= 1) {
		// 		return;
		// 	}
		// 	this.swiper = new Swiper(this.$el[0], args);
		// } else {
		// 	this.swiper.destroy(true, true);
		// }

		//this.addEvents( b );
	}

	formatNumber(i) {
		return i < 10 ? "0" + i : i;
	}

	centerCaptions() {
		let scopeThis = this;
		$(".collapse-size .img-wrap img")
			.not(".img-processed")
			.each(function () {
				let domEl = $(this);
				let renderedSize = scopeThis.getImgSizeInfo($(this)[0]);
				if (!isNaN(renderedSize.width)) {
					domEl.addClass("img-processed");
					domEl
						.closest(".collapse-size")
						.attr(
							"style",
							"--contentW:" + renderedSize.width + "px"
						);
				} else {
					clearTimeout(scopeThis.timerTimer);
					scopeThis.timerTimer = setTimeout(function () {
						scopeThis.centerCaptions();
					}, 1000);
				}
			});
	}

	getRenderedSize(contains, cWidth, cHeight, width, height, pos) {
		var oRatio = width / height,
			cRatio = cWidth / cHeight;
		return function () {
			if (contains ? oRatio > cRatio : oRatio < cRatio) {
				this.width = cWidth;
				this.height = cWidth / oRatio;
			} else {
				this.width = cHeight * oRatio;
				this.height = cHeight;
			}
			this.left = (cWidth - this.width) * (pos / 100);
			this.right = this.width + this.left;
			return this;
		}.call({});
	}

	getImgSizeInfo(img) {
		var pos = window
			.getComputedStyle(img)
			.getPropertyValue("object-position")
			.split(" ");
		return this.getRenderedSize(
			true,
			img.width,
			img.height,
			img.naturalWidth,
			img.naturalHeight,
			parseInt(pos[0])
		);
	}

	initImages() {
		if (this.$el.hasClass("module-slideshow-a")) {
			let $img_wrap, $img;
			this.$el.find(".img-wrap").each((i, el) => {
				$img_wrap = $(el);
				$img = $img_wrap.find("img");
				// console.log($img.attr("height"), $img.attr("width"));
				if ($img.attr("height") >= $img.attr("width") * 0.76) {
					$img_wrap.addClass("vertical");
				} else {
					$img_wrap.addClass("horizontal");
				}
			});
		}
	}

	/*
    addEvents( b ){
		if ( b ){
		}
		else{
		}
		this.debounceResize(b);
    }
	*/

	/*
    debounceResize(b){
		if ( b ){
			// debounce resize
			this._debResize = _debounce( () => {
				this.onResize();
			}, 117 );
			this.$win.on( 'resize', this._debResize );
		}
		else{
			if ( this._debResize ){
				this._debResize.cancel();
				this.$win.off( 'resize', this._debResize );
			}        
		}
    }
    */

	/*
    onResize(){
    }
	*/

	/*
    attachEventsKeyBoard( b ){
		if ( b ){
			if  ( !this.events_keyboard_attach ){
				this.events_keyboard_attach =   true;      
				this.$doc.on( 'keydown' , (e) => {
					if ( !inView.is( this.$el[0] ) ){
						return;
					}
					if( e.which === 39 || e.which === 40 ){
						// right arrow or dn
						this.nextSlide( true );
					}
					else if ( e.which === 37 || e.which === 38 ){
						// left arrow or up
						this.nextSlide( false );
					}
				});
			}
		}
		else{
			this.$doc.off( 'keydown' );
			this.events_keyboard_attach =   false;
		}
    }
    */

	destroy() {
		this.initSlider(false);
		this.$el.removeData();
	}
}
